export default "__VITE_ASSET__DPBdvPnR__"